import type { AdReviewApi } from './types'

import type { PagingRequest } from '#/api/type'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export const adReviewApi = defineApi('operation', ({ prefix }) => {
  // 查询广告审核列表，暂不使用
  function getAdReviewList(params: PagingRequest<AdReviewApi.QueryParams>) {
    params = {
      pageIndex: params.pageIndex,
      pageSize: params.pageSize,
      condition: {
        types: params.condition.types,
        machineApproveStatus: params.condition.machineApproveStatus,
        operationApproveStatus: params.condition.operationApproveStatus,
        companyId: params.condition.companyId,
        companyName: params.condition.companyName,
        accountId: params.condition.accountId,
        campaignId: params.condition.campaignId,
        auditId: params.condition.auditId,
        violationCategory: params.condition.violationCategory,
        isCloseDoor: params.condition.isCloseDoor,
        isFalseAdvertising: params.condition.isFalseAdvertising,
      },
    }
    return requestClient
      .post(prefix('adsGovernor/query'), params)
      .then((res) => {
        return {
          items:
            res.list?.map((item: AdReviewApi.AdListItem) => ({
              accountId: item.accountId,
              campaignId: item.campaignId,
              adsetId: item.adsetId,
              adId: item.adId,
              changeRecordId: item.changeRecordId,
              companyName: item.companyName,
              adInfo: item.adInfo,
              machineResult: item.machineResult,
              machineTime: item.machineTime,
              machineStatus: item.machineStatus,
              operationBy: item.operationBy,
              operationResult: item.operationResult,
              operationTime: item.operationTime,
              operationStatus: item.operationStatus,
              createdTime: item.createdTime,
              tags: {
                IMAGE: item.tags.IMAGE || [],
                MESSAGE: item.tags.MESSAGE || [],
                TITLE: item.tags.TITLE || [],
                VIDEO: item.tags.VIDEO || [],
              },
            })) || [],
          total: res.total,
        }
      })
  }

  // 人工审核通过/不通过
  function approveAdReview(params: AdReviewApi.ApproveParams) {
    const requestParams = {
      auditId: params.auditId,
      operationStatus: params.operationStatus,
      operationResult: params.operationResult,
      isNotice: params.isNotice,
      noticeMessage: params.noticeMessage,
      badcase: params.badcase,
      goodcase: params.goodcase,
    }
    return requestClient.post(
      prefix('adsGovernor/approveMaterial'),
      requestParams,
    )
  }

  // 获取违规标签
  function getViolationCategories() {
    return requestClient
      .get(prefix('adsGovernor/violationCategories'))
      .then((res) => {
        return (
          res.map((item: any) => ({
            label: item.label,
            value: item.value,
          })) || []
        )
      })
  }

  // 查询素材列表
  function getMaterialList(
    params: PagingRequest<AdReviewApi.MaterialQueryCondition>,
  ) {
    return requestClient
      .post<AdReviewApi.MaterialListData>(
        prefix('adsGovernor/materials'),
        params,
      )
      .then((res) => {
        return {
          items: res.list || [],
          total: res.total,
        }
      })
  }

  // 查询素材关联的广告信息
  function getMaterialAdInfos(params: AdReviewApi.MaterialAdInfoParams) {
    return requestClient
      .post<
        AdReviewApi.MaterialAdInfo[]
      >(prefix('adsGovernor/materialAdInfos'), params)
      .then((res) => {
        return res || []
      })
  }

  // 查询素材信息
  // 返回数据包含 materialItem（素材详情）和 relatedAccounts（关联的广告账户列表）
  function getMaterialInfo(params: AdReviewApi.MaterialAdInfoParams) {
    return requestClient
      .post<AdReviewApi.MaterialInfoResponse>(
        prefix('adsGovernor/materialInfo'),
        params,
      )
      .then((res) => {
        return (
          res || {
            materialItem: {} as AdReviewApi.MaterialAdInfo,
            relatedAccounts: [],
          }
        )
      })
  }

  return {
    getAdReviewList,
    approveAdReview,
    getViolationCategories,
    getMaterialList,
    getMaterialAdInfos,
    getMaterialInfo,
  }
})
